import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { ComponentProxyDirective } from '@frontend/sports/deferred/feature/component-loader';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxIf } from '@rx-angular/template/if';

import { SGPBadgeComponent } from '../bet-builder/components/badge/sgp-badge/sgp-badge.component';
import { TranslationToStringPipe } from '../cds/translation.pipe';
import { ShowInEpcotDirective } from '../common/epcot-config.directive';
import { ExpansionPanelComponent } from '../common/expansion-panel/expansion-panel.component';
import { ItemComponent } from '../common/item/item.component';
import { BadgeComponent } from '../crm-promotion/badge.component';
import { CrmPromotionModule } from '../crm-promotion/crm-promotion.module';
import { DirectivesModule } from '../directives/directives.module';
import { GridModule } from '../grid/grid.module';
import { OptionGroupListComponent } from '../option-group/option-group-list.component';
import { OptionGroupRendererDirective } from '../option-group/option-group-renderer.directive';
import { OptionPanelComponent } from '../option-group/option-panel.component';
import { OptionSheetViewModule } from '../option-sheet-view/option-sheet-view.module';
import { WidgetCommonModule } from '../widget/common/widget-common.module';
import { WidgetCoreModule } from '../widget/core/widget-core.module';
import { TopEventsBetBuilderComponent } from './top-events-betbuilder/top-events-betbuilder.component';
import { TopEventsGridComponent } from './top-events-grid/top-events-grid.component';
import { TopEventsOutrightComponent } from './top-events-outrights/top-events-outright.component';
import { TopEventsPodBodyComponent } from './top-events-pod-body/top-events-pod-body.component';
import { TopEventsPodHeaderComponent } from './top-events-pod-header/top-events-pod-header.component';
import { TopEventsPodMetadataComponent } from './top-events-pod-metadata/top-events-pod-metadata.component';
import { TopEventsPodComponent } from './top-events-pod/top-events-pod.component';
import { TopEventsPropsHandpickedOptionsComponent } from './top-events-props-handpickedoptionspod/top-events-props-handpickedoptionspod.component';
import { TopEventsPropsMultiPodComponent } from './top-events-props-multipod/top-events-props-multipod.component';
import { TopEventsShowMoreLessButtonComponent } from './top-events-show-more-less-button/top-events-show-more-less-button.component';
import { TopEventsSingleComponent } from './top-events-single/top-events-single.component';

@NgModule({
    imports: [
        CommonModule,
        CompetitionLogoComponent,
        TranslationToStringPipe,
        DirectivesModule,
        WidgetCoreModule,
        WidgetCommonModule,
        CrmPromotionModule,
        GridModule,
        ParticipantImageComponent,
        ComponentProxyDirective,
        ShowInEpcotDirective,
        ItemComponent,
        ExpansionPanelComponent,
        TrustPipe,
        RxIf,
        OptionGroupRendererDirective,
        BadgeComponent,
        OptionPanelComponent,
        OptionGroupListComponent,
        OptionSheetViewModule,
        IconCustomComponent,
        NativePriceFormatterPipe,
        SGPBadgeComponent,
        NgOptimizedImage,
    ],
    declarations: [
        TopEventsPodComponent,
        TopEventsPodHeaderComponent,
        TopEventsPodMetadataComponent,
        TopEventsPodBodyComponent,
        TopEventsShowMoreLessButtonComponent,
        TopEventsSingleComponent,
        TopEventsOutrightComponent,
        TopEventsGridComponent,
        TopEventsPropsMultiPodComponent,
        TopEventsPropsHandpickedOptionsComponent,
        TopEventsBetBuilderComponent,
    ],
    exports: [TopEventsPodComponent],
})
export class TopEventsModule {}
